export default {"src":"/_next/static/media/github.08132f3b.svg","height":20,"width":22};